import { NAMESPACE_PATTERN } from '@cli-constants/patterns.js'

export function validateAdminNamespace(value: string): string {
  const segment = value.trim()

  if (!NAMESPACE_PATTERN.test(segment)) {
    throw new Error(
      'Namespace must be one lowercase kebab-case segment starting with a letter, for example "admin" or "admin-panel".'
    )
  }

  return segment
}
